import ModalPresenter from "../../modal/presenter/modal.js";
import ModalSectionView from "../view/modal.js";

import Animation from "../../animation/animation.js";

import {
  MODAL_MAIN_CLASS
} from "../const.js";

import {
  ActionType
} from "../const.js";

export default class ModalCaptcha extends ModalPresenter {
  constructor() {
    super();

    this._animation = new Animation();
    this._modalMainClass = MODAL_MAIN_CLASS;
    this._modalSectionView = new ModalSectionView();
    this._handleApplyButtonClick = this._handleApplyButtonClick.bind(this);

    this._masterModel = null;
  }

  build() {
    super.build();
    this._modalSectionView.setApplyButtonClickHandler(this._handleApplyButtonClick);
  }

  setMasterModel(model) {
    this._masterModel = model;
  }

  _handleApplyButtonClick() {
    const modelData = this._masterModel.getData();
    this._masterModel.changeData(Object.assign(
        {},
        modelData,
        {
          modalRendered: false,
          passed: true
        }
    ), ActionType.DESTROY_MODAL);
  }
}
